import { MainImages } from '@lemon/assets';
import { headers } from '../layout/header/Header';

import useEmblaCarousel from 'embla-carousel-react';

export const Philosophy = () => {
    const [emblaRef] = useEmblaCarousel({ align: 'center', containScroll: 'trimSnaps' });

    return (
        <section
            id={headers[1].id}
            className="w-full h-full flex flex-col items-center justify-center pt-[120px] md:pt-[500px] overflow-hidden"
        >
            <header className="mb-[60px] md:mb-0">
                {/* Desktop Title */}
                <h1 className="hidden md:block text-[80px] lg:text-[180px] font-bold text-white">we bring out</h1>
                {/* Mobile Title (Vertical) */}
                <div className="md:hidden flex flex-col items-center">
                    <h1 className="text-[90px] leading-[90px] font-bold text-white">we</h1>
                    <h1 className="text-[90px] leading-[90px] font-bold text-white">bring</h1>
                    <h1 className="text-[90px] leading-[90px] font-bold text-white">out</h1>
                </div>
            </header>

            {/* Desktop View (Grid/Flex) */}
            <main className="hidden md:flex max-w-[1200px] mx-auto w-full justify-between items-center gap-4 px-4">
                {data.map(item => (
                    <PhilosophyItem key={item.title} item={item} className="flex-1 min-w-0" />
                ))}
            </main>

            {/* Mobile View (Carousel) */}
            <div className="md:hidden w-full pl-5" ref={emblaRef}>
                <div className="flex gap-[20px]">
                    {data.map(item => (
                        <div key={item.title} className="flex-[0_0_85%] min-w-0">
                            <PhilosophyItem item={item} />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

const PhilosophyItem = ({ item, className }: { item: (typeof data)[0]; className?: string }) => (
    <article className={`flex flex-col items-center justify-center gap-[30px] md:gap-[60px] ${className}`}>
        <figure className="w-full flex justify-center">
            <img
                className="w-full max-w-[380px] h-auto md:h-[500px] object-cover"
                src={item.image}
                alt={item.description}
                onDragStart={e => e.preventDefault()}
            />
        </figure>

        <div className="flex flex-col items-center justify-center gap-4 md:gap-8">
            <h2 className="text-[24px] md:text-[32px] font-bold text-white">{item.title}</h2>
            <p className="text-[16px] md:text-2xl text-white/60 text-center whitespace-pre-line">{item.description}</p>
        </div>
    </article>
);

const data = [
    {
        image: MainImages.awareness,
        title: 'Awareness',
        description: '데이터 기반 \n나 자신을 깊이 이해할 수 있습니다.',
    },
    {
        image: MainImages.discovery,
        title: 'Discovery',
        description: '숨겨진 개성을 발견하고 \n새로운 자기 인식을 확장합니다.',
    },
    {
        image: MainImages.expression,
        title: 'Expression',
        description: '일상 속에서 당신만의 매력을 \n자신 있게 드러냅니다.',
    },
];
